export function setPageDownloadLoading (state, loading = false) {
  state.pagedownloadLoading = loading
}

export function setDownloads (state, data ) {
  state.downloads = data.downloads.data
  state.downloadsCurrentPage = data.downloads.current_page
  state.downloadsLastPage = data.downloads.last_page
  state.downloadsPerPage = data.downloads.per_page
  state.downloadsTotal = data.downloads.total
}

export function setIndexPage (state, page = null) {
  state.indexPage = page
}

export function setSearch (state, search = '') {
  state.search = search
}
